import React, { useState, useEffect } from "react";
import { query, collection, limit, orderBy, where } from "firebase/firestore";
import { useLeague } from "context/leagueContext";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import UserList from "components/userList";
import { useTranslation } from "react-i18next";
import { classNames } from "utils/utils";

const KnockoutList = ({ eliminated, resultLimit }) => {
  const [userList, setUserList] = useState([]);

  const {
    state: { leagueUserData, leagueInfo },
  } = useLeague();
  const firestore = useFirestore();
  const { t } = useTranslation();

  let totalCount = leagueInfo?.userCount ? leagueInfo?.userCount : 0;
  let eliminatedCount = leagueInfo?.eliminatedCount
    ? leagueInfo?.eliminatedCount
    : 0;
  let remainingCount = totalCount - eliminatedCount;

  let count = eliminated ? eliminatedCount : remainingCount;

  const userCollection =
    leagueInfo?.id &&
    collection(firestore, "userTournaments/" + leagueInfo?.id + "/users");

  let userQuery = query(
    userCollection,
    where("gameOver", "==", eliminated ? true : false),
    limit(25)
  );

  if (leagueInfo?.gameRule == 2) {
    userQuery = query(userQuery, orderBy("drawCount", "asc"));
  }

  userQuery = query(userQuery, limit(resultLimit ? resultLimit : 25));
  const { status: userStatus, data: userData } = useFirestoreCollectionData(
    userQuery,
    {
      idField: "id",
    }
  );
  useEffect(() => {
    if (userData && leagueInfo?.id) {
      let data = userData.filter((item) => item.id !== leagueUserData?.userId);

      if (eliminated ? leagueUserData?.gameOver : !leagueUserData?.gameOver) {
        data.unshift(leagueUserData);
      }

      const data2 = data.map((doc) => ({
        id: doc.id,
        userId: doc.userId,
        gameOver: doc.gameOver,
        drawCount: doc.drawCount,
        photo: doc.photo,
        nickname: doc.nickname,
      }));

      setUserList(data2);
    }
  }, [userData, leagueInfo?.id]);
  return (
    <div className="mx-2 my-2">
      <div className="block uppercase tracking-wide text-xs mb-1 pl-2 text-textPrimary">
        {eliminated
          ? t("tournament.leaderboard.eliminated")
          : leagueInfo?.settled
          ? t("lobby.card.winner")
          : t("tournament.leaderboard.remaining")}
      </div>
      <div
        className={classNames(
          eliminated ? "bg-white/40" : "bg-white",
          "rounded-md p-4 pr-2 mb-4"
        )}
      >
        <UserList
          participants={userList}
          isLoading={userStatus === "loading"}
          extra={count}
        />
      </div>
    </div>
  );
};

export default KnockoutList;
